import { render } from "./IncidenciaDelictivaFueroComunComponent.vue?vue&type=template&id=403fc3f8&scoped=true"
import script from "./IncidenciaDelictivaFueroComunComponent.vue?vue&type=script&lang=js"
export * from "./IncidenciaDelictivaFueroComunComponent.vue?vue&type=script&lang=js"

import "./IncidenciaDelictivaFueroComunComponent.vue?vue&type=style&index=0&id=403fc3f8&scoped=true&lang=css"

import exportComponent from "/Users/luismanuel/Documents/www/tuxtlacomovamos/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-403fc3f8"]])

export default __exports__